import React, { FC, FunctionComponent } from "react"
import { observer } from "mobx-react-lite"

import { SwipeRow } from 'react-native-swipe-list-view';
import MapView, { Marker } from 'react-native-maps';

import { Actionsheet, AlertDialog, Badge, Box, Button, Checkbox, HStack, Icon, IconButton, Pressable, ScrollView, Spacer, StatusBar, Text, useDisclose, View, VStack } from "native-base"
import { MaterialIcons, Ionicons, MaterialCommunityIcons, FontAwesome5 } from "@expo/vector-icons";

import { HomeStackParamList, useBackButtonHandler } from "../../navigators"
import { DrawerScreenProps } from "@react-navigation/drawer"
import { useStores } from "../../models"
import { ITEM_STATUS } from "../../voolks/types";
import { getIconItem, getItemTitle, openPDF, getIconItemPTW, getGPSCoords } from "../../utils/itemCommonFunctions";
import { AppState, Platform } from "react-native";
import * as Storage from "../../utils/storage";

export const PTWHomeScreen: FC<DrawerScreenProps<HomeStackParamList, "ItemsList">> = observer(function PTWHomeScreen({ navigation, route }) {
  const fcName = "ItemsListScreen";
  const { formsStore, itemsStore, statusStore, authenticationStore } = useStores();
  const user = authenticationStore.userInfo.user;
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclose();

  const [alertDialog, setAlertDialog] = React.useState(undefined);
  const [infoModal, setInfoModal] = React.useState(false);
  const [itemsPending, setItemsPending] = React.useState<boolean>(true);
  const [mustSync, setMustSync] = React.useState<boolean>(false);
  const [myLocation, setMyLocation] = React.useState<{ latitude: number, longitude: number }>({ latitude: -34.939, longitude: -58.497 });
  const swipeRows: any[] = [];
  let swipeRow_selected: any;
  const mySubscriptions = formsStore.mySubscriptions();
  const departments = mySubscriptions.subscriptions;
  let my_items: any = itemsStore.myPTWs().reverse().filter(item => (!itemsPending || item.status != "sent" || item.statusPTW == "waiting"));


  const goBack = () => {


  }

  useBackButtonHandler(goBack);

  const newItem = async (department, form) => {
    await itemsStore.new(department.id, form.id, undefined)
    _openItem(form, department);
  };

  const openItem = async (form, department, itemSelected: any = undefined) => {
    _openItem(form, department, itemSelected);
  }

  const _openItem = async (form, department, itemSelected: any = undefined) => {
    console.log(fcName, "_openItem", "Init");
    if (itemSelected)
      await itemsStore.activateItem(itemSelected)
    if (itemsStore.itemActiveIDX != undefined) {
      await itemsStore.makePayloadFromFormPages(form.pages);
      navigation.navigate("ItemDetails", {
        itemStartedAt: new Date().getTime(),
        formId: form.id,
        deptId: department.id,
        forReview: itemsStore.itemActive.status != ITEM_STATUS.draft.toString(),
        taskId: undefined,
        pageActive: 0,
        rnd: new Date().getTime()
      })
    }
    console.log(fcName, "_openItem", "Fin");
  }

  const removeItemsDialog = async (department, form, item: any = undefined) => {
    let lstIdx: number[] = [];
    let alert = { title: "", message: "" };
    if (item != undefined) {
      let itemIdx: number = itemsStore.getIDXofItem(item)
      if (itemIdx > -1) {
        lstIdx.push(itemIdx);
      }
      alert.title = `Borrar registro ${form.name}`;
      alert.message = `¿Estas seguro de borrar el registro  ${getItemTitle(form, item)}?`;
      setAlertDialog({
        ...alert,
        action: () => {
          swipeRows.map(async (row) => {
            await row?.closeRow();
          });
          lstIdx.sort((a, b) => { return b - a; }).forEach(idx => itemsStore.removeItem(idx));
        }
      })
    }
  }

  const checkMustSync = async () => {
    setMustSync((await Storage.getItem("must_sync")) != undefined);
    console.log(mustSync)
  }

  React.useEffect(() => {
    getGPSCoords().then((gps: any) => {
      if (gps)
        setMyLocation({ latitude: gps.coords.latitude, longitude: gps.coords.longitude });
    });
    checkMustSync();
    const listener = AppState.addEventListener("change", checkMustSync);
    return () => {
      listener.remove();
    }
  }, [])


  const ItemsListRows: FunctionComponent = () => {
    try {
      return <>
        {my_items
          .map((item: any, idx: number) => {
            const department = departments.find((dept: any) => dept.id == item.deptId);
            if (department == undefined)
              return <></>;
            const form = (department.forms || []).find((form: any) => form.id == item.formId);
            if (form == undefined)
              return <></>;
            return (
              <SwipeRow key={`SwipeRow${idx}`} leftOpenValue={110} rightOpenValue={-55}
                ref={(c) => { swipeRows[idx] = c; }}
                onRowOpen={() => {
                  if (swipeRow_selected && swipeRow_selected !== swipeRows[idx]) { swipeRow_selected.closeRow(); }
                  swipeRow_selected = swipeRows[idx];
                }}
              >
                <View style={{ minHeight: 45, flexWrap: "wrap", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                  <View ><IconButton isDisabled={item.status != ITEM_STATUS.sent} onPress={() => openPDF(itemsStore, item)} w="55" borderRadius={0} bgColor={"success.500"} icon={<Icon as={FontAwesome5} name="file-pdf" size="md" color="white" />} /></View>
                  <View ><IconButton isDisabled={item.status != ITEM_STATUS.sent} onPress={() => openPDF(itemsStore, item, true)} w="55" borderRadius={0} bgColor={"yellow.500"} icon={<Icon as={Ionicons} name="mail" size="md" color="white" />} /></View>
                  <Spacer></Spacer>
                  <View ><IconButton isDisabled={item.status == ITEM_STATUS.sent} w="55" borderRadius={0} bgColor={"danger.500"}
                    icon={<Icon as={Ionicons} name="trash-outline" size="md" color="white" />}
                    onPress={() => removeItemsDialog(department, form, item)}
                  /></View>
                </View>
                <View borderBottomWidth={1} borderBottomColor={"light.300"} style={{ minHeight: 45, flexWrap: "wrap", backgroundColor: "white", justifyContent: "center", }}  >
                  <Pressable px="3" _pressed={{ bg: "secondary.600:alpha.20" }} _hover={{ bg: "secondary.600:alpha.20" }}
                    onPress={() => openItem(form, department, item)} style={{ flexDirection: "row" }}>
                    <HStack py="3" width={"full"} alignItems="center">
                      {getIconItem(item.status)}
                      <VStack px="3" maxWidth={"85%"}>
                        <Text lineHeight="xs" fontSize="md">{getItemTitle(form, item)}</Text>
                        <Text fontSize="xs">{department.name}  {form.name}</Text>
                      </VStack>
                      {getIconItemPTW(item.statusPTW)}
                      <Spacer></Spacer>
                      <Icon name="arrow-forward" as={Ionicons} size="md" />
                    </HStack>
                  </Pressable>
                </View>

              </SwipeRow>

            )
          })}
      </>;
    }
    catch (e) {
      return <><Text>Error</Text></>
    }

  }
  const someToUpload =
    my_items.reduce((counter, item) => {
      return counter + (item.status == ITEM_STATUS.closed ? 1 : 0)
    }, 0);
  const svgMarkerUser = {
    path: "M375.935,375.033c-10.498-5.408-22.442-10.275-35.512-14.472c-0.767-0.409-2.272-1.216-4.303-2.33 c-16.668-9.184-29.807-17.867-36.12-23.803v-24.286c30.385-17.372,51.163-48.542,57.804-86.695 C375.017,218.518,390,202.361,390,187.5c0-15.043-11.308-25.026-30-27.094V150h35v-7.5c0-9.655-8.382-46.807-27.002-47.469 C355.397,57.703,326.775,27.87,290,13.748V0h-95v13.748c-36.824,14.137-65.464,43.973-78.033,81.285 C98.372,95.74,90,132.851,90,142.5v7.5h35v10.406c-18.692,2.068-30,12.051-30,27.094c0,14.861,14.983,31.019,32.196,35.948 c6.647,38.167,27.429,69.336,57.804,86.695v24.285c-6.312,5.936-19.45,14.618-36.106,23.795c-2.06,1.13-3.577,1.943-4.338,2.349 c-13.408,4.401-25.363,9.341-35.485,14.658c-62.571,32.182-64.037,75.318-64.069,77.139L45,485h395v-32.537 C439.991,450.626,439.051,407.119,375.935,375.033z M340,376.218c9.011,3.058,17.38,6.448,25,10.127V430h-25V376.218z M375,187.5 c0,6.126-6.627,14.467-15.266,19.07c0.165-2.964,0.266-31.088,0.266-31.088C373.367,177.356,375,184.268,375,187.5z M290,29.958 C318.457,42.536,340.807,65.964,352.045,95H290V29.958z M210,15h65v80h-65V15z M195,29.956V95h-62.081 C144.134,65.976,166.5,42.545,195,29.956z M110,187.5c0-3.232,1.633-10.144,15-12.018c0,0,0.101,28.125,0.266,31.088 C116.627,201.966,110,193.626,110,187.5z M105.912,135c2.285-10.771,8.315-23.686,11.757-25h249.662 c3.442,1.314,9.472,14.229,11.757,25H105.912z M141.227,216.156C140.413,210.366,140,204.09,140,197.5V150h205v47.5 c0,6.59-0.413,12.866-1.229,18.674c-5.158,37.347-25.101,67.55-54.733,82.874C275.075,306.315,259.417,310,242.5,310 s-32.575-3.685-46.555-10.962C166.331,283.724,146.388,253.521,141.227,216.156z M285,317.299v17.312 C279.87,339.974,263.613,355,242.5,355c-20.977,0-37.346-15.055-42.5-20.404v-17.298c13.182,5.108,27.424,7.702,42.5,7.702 C257.579,325,271.824,322.405,285,317.299z M160,369.204c9.754-5.509,23.203-13.621,32.241-21.169 C200.885,356.174,219.023,370,242.5,370s41.615-13.826,50.259-21.966c9.035,7.546,22.48,15.656,32.241,21.169V430H160V369.204z M120,386.509c7.426-3.641,15.798-7.078,25-10.258V430h-25V386.509z M90.2,470H60v-17.37c0.093-2.065,2.189-31.708,45-57.922 V430.2c-8.466,1.22-15,8.502-15,17.3v20C90,468.351,90.082,469.181,90.2,470z M380,467.5c0,1.355-1.145,2.5-2.5,2.5h-270 c-1.355,0-2.5-1.145-2.5-2.5v-20c0-1.355,1.145-2.5,2.5-2.5h270c1.355,0,2.5,1.145,2.5,2.5V467.5z M425,470h-30.2 c0.118-0.819,0.2-1.649,0.2-2.5v-20c0-8.798-6.534-16.081-15-17.3v-35.764c43.445,26.306,44.951,56.392,45,58.136V470z",
    fillColor: "green",
    fillOpacity: 1,
    strokeWeight: 1,
    strokeColor: "green",
    rotation: 0,
    scale: 0.05
  };

  const svgMarkerWarning = {
    path: "M108.186,144.372c0,7.054-4.729,12.32-12.037,12.32h-0.254c-7.054,0-11.92-5.266-11.92-12.32 c0-7.298,5.012-12.31,12.174-12.31C103.311,132.062,108.059,137.054,108.186,144.372z M88.44,125.301h15.447l2.951-61.298H85.46 L88.44,125.301z M190.372,177.034c-2.237,3.664-6.214,5.921-10.493,5.921H12.282c-4.426,0-8.51-2.384-10.698-6.233 c-2.159-3.849-2.11-8.549,0.147-12.349l84.111-149.22c2.208-3.722,6.204-5.96,10.522-5.96h0.332 c4.445,0.107,8.441,2.618,10.513,6.546l83.515,149.229C192.717,168.768,192.629,173.331,190.372,177.034z M179.879,170.634 L96.354,21.454L12.292,170.634H179.879z",
    fillColor: "orange",
    fillOpacity: 1,
    strokeWeight: 1,
    strokeColor: "orange",
    rotation: 0,
    scale: 0.15
  };

  const cancelRef = React.useRef();
  return statusStore.status == "pending"?<></>:(<>
    <StatusBar backgroundColor={"#3700B3"} barStyle="light-content" />
    <Box safeAreaTop bg="primary.400" />
    <HStack bg="primary.400" px="0" py="0" justifyContent="space-between" alignItems="center" w="100%">
      <HStack alignItems="center" maxW={statusStore.windowDimensions.width - 140}>
        <VStack>
          <Text color="white" fontSize="18" ml={1} >
            Permisos de trabajo
          </Text>
          <Text color="white" fontSize="10" ml={1}>ult. sinc.: {new Date(mySubscriptions.lastSync).getYYYYMMddHHmmss()}</Text>
        </VStack>
      </HStack>
      <HStack>
        <IconButton variant={"solid"} onPress={async () => setInfoModal(true)}
          icon={<Icon as={MaterialCommunityIcons} name="help-circle" size="md" />}
        />
        <VStack mr="1">{someToUpload > 0 ?
          <Badge // bg="red.400"
            colorScheme="danger" rounded="full" mb={-5} mr={0}
            zIndex={1}
            variant="solid" alignSelf="flex-end" _text={{
              fontSize: "2xs"
            }}>
            {someToUpload}
          </Badge> : null
        }
          {mustSync ?
            <Badge
              colorScheme="yellow" rounded="full" mb={-5} ml={0}
              zIndex={1}
              variant="solid" alignSelf="flex-start" _text={{
                fontSize: "2xs"
              }}>
              !
            </Badge> : null
          }
          <IconButton variant={"solid"} onPress={async () => { Storage.removeItem("must_sync"); await itemsStore.upload({}); formsStore.getSubscriptions(); checkMustSync() }}
            icon={<Icon as={MaterialCommunityIcons} name="cloud-sync-outline" size="xl" />}
          />
        </VStack>


      </HStack>
    </HStack>

    <VStack bg="white" flex={1}>
      <HStack bgColor={"black"} px="5" py="1" my="0" justifyContent="center" alignItems="center" w="100%" borderBottomWidth={1} borderBottomColor={"light.300"} >
        <Button.Group isAttached colorScheme="secondary" size="sm">
          <Button variant={!itemsPending ? "solid" : "subtle"} onPress={() => setItemsPending(false)}>TODOS</Button>
          <Button variant={itemsPending ? "solid" : "subtle"} onPress={() => setItemsPending(true)}>Mis Pendientes</Button>
        </Button.Group>
      </HStack>

      <>
        <ScrollView><ItemsListRows /></ScrollView>
        <Spacer />
        {itemsPending ?
          <HStack height="1/2" bgColor="amber.200">
            {Platform.OS == "web" ?
              <MapView defaultZoom={13} region={myLocation} style={{
                width: '100%',
                height: '100%',
              }} >
                <MapView.Marker
                  key="markerUser"
                  icon={svgMarkerUser}
                  title={user.firstName.concat(" ", user.lastName)}
                  description="Tu ubicación"
                  coordinate={myLocation}
                />
                {my_items.map((item, idx) => {
                  try {
                    let dept = departments.find(dept => dept.id == item.deptId);
                    if (dept == undefined)
                      return <></>;
                    let form = dept.forms.find(form => form.id == item.formId);
                    if (form == undefined)
                      return <></>;
                    let geoFieldId = form.metadata.find(meta => meta.key == "PTW_GEO")
                    if (geoFieldId && geoFieldId.value != "" && item.payload.toJSON()[geoFieldId.value]?.value != undefined) {
                      const geoElement = item.payload.toJSON()[geoFieldId.value];
                      let coords = geoElement.value.coords;
                      if (geoElement.type !== "geo") {
                        let value = geoElement.value.replace("*|", "").replace("OTHER|##", "").replace("##", "");
                        coords = { latitude: parseFloat(value.split(",")[0]), longitude: parseFloat(value.split(",")[1]) }
                      }
                      return <MapView.Marker key={idx}
                        icon={item.statusPTW == "waiting" ? svgMarkerWarning : null}
                        title={getItemTitle(form, item)}
                        description={item.statusPTW}
                        coordinate={coords}
                        onPress={() => {
                          openItem(form, dept, item)
                        }}
                      />
                    } else
                      return null;
                  } catch (e) {
                    console.log("PTWHomeScreen my_items.map", e)
                  }
                })}

              </MapView>
              : //Android
              <MapView style={{
                width: '100%',
                height: '100%',
              }} showsUserLocation={true}
                region={{
                  latitudeDelta: 0.0922,
                  longitudeDelta: 0.0421, ...myLocation
                }}
              >
                {my_items.map((item, idx) => {
                  try {
                    let dept = departments.find(dept => dept.id == item.deptId);
                    if (dept == undefined) return null;
                    let form = dept.forms.find(form => form.id == item.formId);
                    if (form == undefined) return null;

                    let geoFieldId = form.metadata.find(meta => meta.key == "PTW_GEO")
                    if (geoFieldId && geoFieldId.value != "" && item.payload.toJSON()[geoFieldId.value]?.value != undefined) {
                      const geoElement = item.payload.toJSON()[geoFieldId.value];
                      let coords = geoElement.value.coords;
                      if (geoElement.type !== "geo") {
                        let value = geoElement.value.replace("*|", "").replace("OTHER|##", "").replace("##", "");
                        console.log(value);
                        coords = { latitude: parseFloat(value.split(",")[0]), longitude: parseFloat(value.split(",")[1]) }
                      }
                      if (coords.latitude == "" || coords.longitude == "" || isNaN(coords.latitude) || isNaN(coords.longitude))
                        return null;
                      else {
                        console.log(getItemTitle(form, item), coords);
                        return <Marker key={idx}
                          pinColor={item.statusPTW == "waiting" ? "orange" : "red"}
                          title={getItemTitle(form, item)}
                          description={item.statusPTW}
                          coordinate={coords}
                          onPress={() => {
                            openItem(form, dept, item)
                          }}
                        />
                      }
                    }
                    return null;
                  } catch (e) {
                    console.log("PTWHomeScreen my_items.map", e)
                  }
                })}
              </MapView>}
          </HStack>
          :
          <></>}
        <HStack>
          <VStack ><Spacer />
            <HStack alignItems={"center"}>
              <IconButton variant={"light"}
                size="md"
                colorScheme="danger" onPress={authenticationStore.signOut}
                icon={<Icon as={MaterialIcons} name="logout" />}
              />
              <Text>{user?.firstName} {user?.lastName}</Text>
            </HStack>
          </VStack>
          <Spacer />
          <IconButton variant={"solid"} size="lg" borderRadius={"full"} m="3" colorScheme="success" onPress={onOpen}
            icon={<Icon as={Ionicons} name="add" />}
          />
          <Actionsheet isOpen={isOpen} onClose={onClose}>
            <Actionsheet.Content>
              <Box w="100%" h={60} px={4} justifyContent="center">
                <Text fontSize="16" color="gray.500" _dark={{
                  color: "gray.300"
                }}>
                  Indique permiso de trabajo a crear:
                </Text>
              </Box>
              {departments.reduce((lst, dept, idX) => {
                lst.push(<Actionsheet.Item startIcon={<Icon as={MaterialIcons} size="6" color={"secondary.700"} name="library-books" />} key={"btn_new".concat(idX)} isDisabled>{dept.name}</Actionsheet.Item>);
                let forms = [].concat(dept.forms);
                lst = lst.concat(forms.sort((a, b) => a.name.localeCompare(b.name)).map((f, idY) => <Actionsheet.Item startIcon={<Icon as={MaterialCommunityIcons} size="4" name="format-list-checks" />} key={"btn_new".concat(idX, "-", idY)}
                  onPress={() => newItem(dept, f)}>{f.name}</Actionsheet.Item>));
                return lst;
              }, [])}
            </Actionsheet.Content>
          </Actionsheet>
        </HStack>
      </>

    </VStack>
    {alertDialog == undefined ? <></> :
      <AlertDialog leastDestructiveRef={cancelRef} isOpen={alertDialog != undefined} >
        <AlertDialog.Content>
          <AlertDialog.CloseButton />
          <AlertDialog.Header>{alertDialog?.title}</AlertDialog.Header>
          <AlertDialog.Body>{alertDialog?.message}</AlertDialog.Body>
          <AlertDialog.Footer>
            <Button ref={cancelRef} onPress={() => setAlertDialog(undefined)}>
              Cancelar
            </Button>
            <Button colorScheme="red" ml={3} onPress={() => { alertDialog?.action(); setAlertDialog(undefined) }}>
              Aceptar
            </Button>
          </AlertDialog.Footer>
        </AlertDialog.Content>
      </AlertDialog>
    }

    <AlertDialog leastDestructiveRef={cancelRef} isOpen={infoModal} onClose={() => setInfoModal(false)} size={"xl"}>
      <AlertDialog.Content>
        <AlertDialog.CloseButton />
        <AlertDialog.Header>Descripción iconos</AlertDialog.Header>
        <AlertDialog.Body >
          <VStack >
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("draft")}
              <Text ml="24px">Registro nuevo para ser completado.</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("draft")}
              {getIconItemPTW("pending")}
              <Text width={"80%"} >Registro creado por otro usuario y que debo completar</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("draft")}
              {getIconItemPTW("finished")}
              <Text>Permiso aprobado, debo cerrar trabajo</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("closed")}
              <Text width={"90%"} ml="24px">Registro completado listo para subirse al servidor.</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("closed")}
              {getIconItemPTW("pending")}
              <Text width={"90%"}>Registro creado por otro usuario, que ya complete y debo subir al servidor</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("sent")}
              {getIconItemPTW("inprogress")}
              <Text width={"90%"} >Registro en el que ya participe, y que continua su workflow</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("sent")}
              {getIconItemPTW("waiting")}
              <Text width={"80%"} >Registro en el que debo participar, pero esta en una etapa previa</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("sent")}
              {getIconItemPTW("finished")}
              <Text width={"90%"} >Registro con aprobación completa, pendiente fin de trabajo</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("sent")}
              {getIconItemPTW("closed")}
              <Text>Trabajo terminado</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("sent")}
              {getIconItemPTW("reject")}
              <Text >Solicitud rechazada</Text>
            </HStack>
            <HStack borderBottomWidth="1" borderBottomColor={"gray.300"} py="1" alignItems="center" >
              {getIconItem("sent")}
              {getIconItemPTW("error")}
              <Text >Error en Workflow</Text>
            </HStack>
          </VStack>
        </AlertDialog.Body>
      </AlertDialog.Content>
    </AlertDialog>

  </>
  )
})